export const resetProductPrice = (products, item) =>
  products.map(product => product.name === item.name
    ? {
        ...product,
        price: item.oldPrice,
        value: item.oldPrice * (product.count || 0),
        oldPrice: undefined,
      }
    : product)
